import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { useSelector } from 'hooks/useSelector';
import { filterArrayEmpty } from 'lib/riskbase';
import React from 'react';
import { Platform } from 'react-native';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL } from 'store/app/actions';
import {
  CLOSE_ASSESSMENT,
  DELETE_ASSESSMENT,
  doAseLoadPdf,
} from 'store/assessments/actions';
import {
  selectAseAssetAstAseMerged,
  selectAseComplianceSubtype,
  selectAseIsOnline,
  selectAseStatus,
} from 'store/assessments/selectors';

export const ExplorerHeader: React.FC = () => {
  const dispatch = useDispatch();

  const complianceSubtype = useSelector(selectAseComplianceSubtype);
  const isOnline = useSelector(selectAseIsOnline);
  const status = useSelector(selectAseStatus);
  const { name: addressName } = useSelector(selectAseAssetAstAseMerged);
  const isApproved = status.id === 'approved';

  return (
    <NavigationHeader
      onPressBackButton={() => dispatch(CLOSE_ASSESSMENT())}
      menuRight={{
        iconButtonConfig: {
          icon: ICONS.EllipsisLight,
        },
        options: [
          !isApproved
            ? {
                text: 'Preview Draft PDF',
                icon: ICONS.FileDuotone,
                onPress: () => dispatch(doAseLoadPdf({})),
              }
            : null,
          !isApproved
            ? {
                text: `${
                  Platform.OS === 'web' ? 'Download' : 'Share'
                } Draft PDF`,
                icon: ICONS.ShareOS,
                onPress: () => dispatch(doAseLoadPdf({ doShare: true })),
              }
            : null,
          isApproved
            ? {
                text: 'Preview Approved PDF',
                icon: ICONS.FileCertificateDuotone,
                onPress: () => dispatch(doAseLoadPdf({})),
              }
            : null,
          isApproved
            ? {
                text: `${
                  Platform.OS === 'web' ? 'Download' : 'Share'
                } Approved PDF`,
                icon: ICONS.ShareOS,
                onPress: () => dispatch(doAseLoadPdf({ doShare: true })),
              }
            : null,
          '-',
          isApproved
            ? {
                text: 'Preview Live PDF',
                icon: ICONS.FileDuotone,
                onPress: () => dispatch(doAseLoadPdf({ live: true })),
              }
            : null,
          isApproved
            ? {
                text: `${
                  Platform.OS === 'web' ? 'Download' : 'Share'
                } Live PDF`,
                icon: ICONS.ShareOS,
                onPress: () =>
                  dispatch(doAseLoadPdf({ live: true, doShare: true })),
              }
            : null,
          '-',
          !isOnline
            ? {
                text: 'Copy Assessment',
                icon: ICONS.CopyLight,
                onPress: () =>
                  dispatch(
                    NAVIGATE_MODAL({
                      screen: ModalScreens.ASECOPY,
                      params: {},
                    }),
                  ),
              }
            : null,
          '-',
          !isOnline && !isApproved
            ? {
                text: 'Delete Assessment',
                onPress: () => dispatch(DELETE_ASSESSMENT()),
                icon: ICONS.TrashCanLight,
                destructive: true,
              }
            : null,
        ].filter(filterArrayEmpty),
      }}
      heading={complianceSubtype.name}
      subheading={addressName}
    />
  );
};
